import { render } from "./Html.vue?vue&type=template&id=66680197&scoped=true"
import script from "./Html.vue?vue&type=script&lang=js"
export * from "./Html.vue?vue&type=script&lang=js"

import "./Html.vue?vue&type=style&index=0&id=66680197&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66680197"]])

export default __exports__